import { gql } from '@apollo/client';

export const FIND_UNIQUE_ATTACHMENT = gql`
  query findUniqueChannelMessageAttachment($id: String!) {
    findUniqueChannelMessageAttachment(where: { id: $id }) {
      id
      url
      attachmentType
      filename
      entityId
      channelMessage {
        id
      }
    }
  }
`;
